﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿<template>
  <div class="home-container">

    <!-- ========== 1. HERO 首屏（企业级大图）========== -->
    <section id="home" class="hero-block">
      <div class="hero-overlay"></div>
      <div class="hero-pattern"></div>
      <div class="hero-geo hero-geo-1"></div>
      <div class="hero-geo hero-geo-2"></div>
      <div class="container hero-content">
        <div class="hero-badge">{{ locale === 'zh' ? (siteConfig.hero_badge_zh || '专业制造 · 值得信赖') : (siteConfig.hero_badge_en || 'Professional & Trusted') }}</div>
<h1 class="hero-title">{{ locale === 'zh' ? (siteConfig.hero_title_zh || '品质铸就品牌') : (siteConfig.hero_title_en || 'Quality Builds Brand') }}</h1>
<p class="hero-desc">{{ locale === 'zh' ? (siteConfig.hero_subtitle_zh || '深耕行业十余年，致力于为客户提供高品质的产品与一站式服务') : (siteConfig.hero_subtitle_en || 'Dedicated to providing high-quality products and one-stop services') }}</p>
        <div class="hero-buttons">
          <a class="btn-primary" href="#products">{{ locale === 'zh' ? '查看产品' : 'View Products' }}</a>
          <a class="btn-outline" href="#contact">{{ locale === 'zh' ? '联系我们' : 'Contact Us' }}</a>
        </div>
        <div class="hero-scroll">
          <span></span>
        </div>
      </div>
    </section>

    <!-- ========== 2. 数据展示块（增强版）========== -->
    <section class="stats-block">
      <div class="container">
        <div class="stats-grid">
          <div class="stat-item" v-for="(s, i) in statsData" :key="i">
            <div class="stat-icon" v-html="s.icon"></div>
            <div class="stat-num">{{ s.num }}</div>
            <div class="stat-label">{{ s.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 分隔装饰条 -->
    <div class="divider-bar">
      <div class="divider-bar-inner"></div>
    </div>

    <!-- ========== 13. 新闻资讯块 ========== -->
    <NewsSection />

    <!-- 分隔装饰条 -->
    <div class="divider-bar">
      <div class="divider-bar-inner"></div>
    </div>

    <!-- ========== 14. CTA 行动召唤 ========== -->
    <section id="about" class="content-block block-light">
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '关于我们' : 'About Us' }}</span>
          <h2 class="block-title">{{ siteConfig.aboutTitle || (locale === 'zh' ? '值得信赖的合作伙伴' : 'A Trusted Partner') }}</h2>
          <p class="block-desc">{{ siteConfig.aboutSubtitle || '' }}</p>
        </div>
        <div class="about-layout center">
          <div class="about-text">
            <div class="about-rich" v-html="locale === 'zh' ? (siteConfig.about_content_zh || '') : (siteConfig.about_content_en || '')"></div>
            <div class="feature-list">
              <div class="feature-item" v-for="(f, i) in aboutFeatures" :key="i">
                <div class="feature-icon" v-html="f.icon"></div>
                <div class="feature-info">
                  <strong>{{ f.title }}</strong>
                  <span>{{ f.desc }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="about-images" v-if="aboutContent.images?.length">
            <div class="image-main">
              <img :src="getImageFullUrl(aboutContent.images[currentImageIndex])" alt="">
              <div class="image-nav" v-if="aboutContent.images.length > 1">
                <button @click="prevImage">‹</button>
                <div class="nav-dots">
                  <span v-for="(img, idx) in aboutContent.images" :key="idx"
                        :class="{ active: currentImageIndex === idx }"
                        @click="currentImageIndex = idx"></span>
                </div>
                <button @click="nextImage">›</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== 4. 核心服务块（一站式解决方案 - 企业级设计）========== -->
    <section v-if="capabilities.length" class="srv-section">
      <div class="srv-geo srv-geo-1"></div>
      <div class="srv-geo srv-geo-2"></div>
      <div class="srv-geo srv-geo-3"></div>
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '核心服务' : 'Our Services' }}</span>
          <h2 class="block-title">{{ locale === 'zh' ? '一站式解决方案' : 'One-Stop Solution' }}</h2>
          <p class="block-desc">{{ locale === 'zh' ? '从设计到交付，全程专业服务，为您创造更大价值' : 'From design to delivery, full professional service' }}</p>
        </div>
        <div class="srv-showcase">
          <div class="srv-card-wrap" v-for="(cap, i) in capabilities" :key="i">
            <div class="srv-card-premium">
              <div class="srv-card-number">{{ String(i + 1).padStart(2, '0') }}</div>
              <h3 class="srv-card-title">{{ locale === 'en' && cap.title_en ? cap.title_en : cap.title }}</h3>
<p class="srv-card-desc">{{ locale === 'en' && cap.desc_en ? cap.desc_en : cap.desc }}</p>
              <div class="srv-card-line"></div>
            </div>
          </div>
        </div>
        <div class="srv-bottom">
          <div class="srv-bottom-line"></div>
          <p class="srv-bottom-text">{{ locale === 'zh' ? '需要定制化解决方案？' : 'Need a customized solution?' }}</p>
          <button class="btn-gold" @click="scrollTo('contact')">{{ locale === 'zh' ? '立即咨询' : 'Contact Now' }}</button>
        </div>
      </div>
    </section>

    <!-- 分隔装饰条 -->
    <div class="divider-bar">
      <div class="divider-bar-inner"></div>
    </div>

    <!-- ========== 6. 产品展示块（上移到前面）========== -->
    <section id="products" class="content-block products-compact">
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '产品中心' : 'Products' }}</span>
          <h2 class="block-title">{{ locale === 'zh' ? '产品展示' : 'Product Showcase' }}</h2>
          <p class="block-desc">{{ locale === 'zh' ? '高品质产品，满足多样化需求' : 'High-quality products for diverse needs' }}</p>
        </div>
        <ProductSection />
      </div>
    </section>

    <!-- ========== 7. 合作流程块（管理端可自定义）========== -->
    <section v-if="processSteps.length" id="process" class="content-block block-light">
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '合作流程' : 'How It Works' }}</span>
          <h2 class="block-title">{{ locale === 'zh' ? '合作流程' : 'Cooperation Process' }}</h2>
          <p class="block-desc">{{ locale === 'zh' ? '简单高效的标准化流程' : 'Simple and efficient process' }}</p>
        </div>
        <div class="steps-grid">
          <div class="step-card" v-for="(step, i) in processSteps" :key="i">
            <div class="step-num">{{ step.number }}</div>
            <h4>{{ locale === 'en' && step.title_en ? step.title_en : step.title }}</h4>
<p>{{ locale === 'en' && step.desc_en ? step.desc_en : step.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== 8. 核心优势块（管理端可自定义）========== -->
    <section v-if="reasons.length" class="advantage-block">
      <div class="container">
        <div class="block-header center light">
          <span class="block-tag tag-light">{{ locale === 'zh' ? '核心优势' : 'Why Choose Us' }}</span>
          <h2 class="block-title light">{{ locale === 'zh' ? '为什么选择我们' : 'Why Choose Us' }}</h2>
          <p class="block-desc light">{{ locale === 'zh' ? '专注品质 用心服务' : 'Quality First Service Best' }}</p>
        </div>
        <div class="advantage-grid">
          <div class="advantage-card" v-for="(r, i) in reasons" :key="i">
            <div class="adv-icon" v-html="r.icon"></div>
            <h4>{{ locale === 'en' && r.title_en ? r.title_en : r.title }}</h4>
            <p>{{ locale === 'en' && r.desc_en ? r.desc_en : r.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== 9. 客户评价块（管理端可自定义）========== -->
    <section v-if="testimonials.length" class="content-block block-light">
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '客户评价' : 'Testimonials' }}</span>
          <h2 class="block-title">{{ locale === 'zh' ? '客户怎么说' : 'What Clients Say' }}</h2>
        </div>
        <div class="review-grid">
          <div class="review-card" v-for="(t, i) in testimonials" :key="i">
            <div class="stars">
              <span v-for="n in 5" :key="n">★</span>
            </div>
            <p class="review-text">"{{ t.text }}"</p>
            <div class="reviewer">
              <div class="avatar">{{ t.name.charAt(0) }}</div>
              <div class="reviewer-info">
                <strong>{{ t.name }}</strong>
                <small>{{ t.company }} · {{ t.role }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== 10. 认证资质块（管理端可自定义，无数据不显示）========== -->
    <section v-if="certifications.length" class="content-block">
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '认证资质' : 'Certifications' }}</span>
          <h2 class="block-title">{{ locale === 'zh' ? '权威认证' : 'Certified Quality' }}</h2>
          <p class="block-desc">{{ locale === 'zh' ? '通过多项国际标准认证' : 'Certified by international standards' }}</p>
        </div>
        <div class="cert-grid-new">
          <div class="cert-item" v-for="(c, i) in certifications" :key="i">
            <div class="cert-icon" v-html="c.icon"></div>
            <strong>{{ locale === 'en' && c.title_en ? c.title_en : c.title }}</strong>
            <span>{{ locale === 'en' && c.desc_en ? c.desc_en : c.desc }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 分隔装饰条 -->
    <div class="divider-bar">
      <div class="divider-bar-inner"></div>
    </div>

    <!-- ========== 11. 合作伙伴块 ========== -->
    <section v-if="partners.length" class="partners-block">
      <div class="container">
        <div class="block-header center light">
          <span class="block-tag tag-light">{{ locale === 'zh' ? '合作伙伴' : 'Partners' }}</span>
          <h2 class="block-title light">{{ locale === 'zh' ? '深受全球品牌信赖' : 'Trusted Globally' }}</h2>
        </div>
        <div class="partner-logos">
          <div class="partner-logo" v-for="(p, i) in partners" :key="i">{{ locale === 'en' && p.name_en ? p.name_en : p.name }}</div>
        </div>
      </div>
    </section>

    <!-- 分隔装饰条 -->
    <div class="divider-bar">
      <div class="divider-bar-inner"></div>
    </div>

    <!-- ========== 12. 常见问题块（管理端可自定义）========== -->
    <section v-if="faqs.length" class="content-block block-light">
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '常见问题' : 'FAQ' }}</span>
          <h2 class="block-title">{{ locale === 'zh' ? '您可能想问' : 'FAQ' }}</h2>
        </div>
        <div class="faq-box">
          <div class="faq-item" v-for="(faq, i) in faqs" :key="i"
               :class="{ open: activeFaq === i }"
               @click="activeFaq = activeFaq === i ? null : i">
            <div class="faq-q">
              <span>{{ faq.question }}</span>
              <span class="faq-arrow">{{ activeFaq === i ? '−' : '+' }}</span>
            </div>
            <div class="faq-a" v-show="activeFaq === i">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== 13. CTA 行动召唤 ========== -->
    <section class="cta-block">
      <div class="container cta-content">
        <span class="block-tag tag-light">{{ locale === 'zh' ? '立即咨询' : 'Get Started' }}</span>
        <h2 class="block-title light">{{ locale === 'zh' ? '准备好合作了吗？' : 'Ready to Partner?' }}</h2>
<p class="block-desc light">{{ locale === 'zh' ? '无论您是品牌商、进口商还是采购代理，我们都能提供专业支持' : 'Whether brand, importer, or agent, we provide professional support' }}</p>
        <div class="cta-buttons">
          <button class="btn-primary" @click="scrollTo('contact')">{{ locale === 'zh' ? '立即咨询' : 'Contact Now' }}</button>
          <button class="btn-outline-light" @click="scrollTo('products')">{{ locale === 'zh' ? '浏览产品' : 'Browse Products' }}</button>
        </div>
      </div>
    </section>

    <!-- ========== 14. 联系我们块 ========== -->
    <section id="contact" class="content-block block-light">
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '联系我们' : 'Contact Us' }}</span>
          <h2 class="block-title">{{ locale === 'zh' ? '与我们取得联系' : 'Get In Touch' }}</h2>
          <p class="block-desc">{{ locale === 'zh' ? '随时为您提供专业咨询与服务' : 'Professional consultation at any time' }}</p>
        </div>
        <div class="contact-layout">
          <div class="contact-cards">
            <div class="contact-card-item" v-for="(c, i) in contactCards" :key="i">
              <div class="card-icon" v-html="c.icon"></div>
              <div>
                <strong>{{ locale === 'en' && c.title_en ? c.title_en : c.title }}</strong>
                <p>{{ locale === 'en' && c.value_en ? c.value_en : c.value }}</p>
              </div>
            </div>
          </div>
          <div class="contact-form-box">
            <form @submit.prevent="submitInquiry">
              <div class="form-group">
                <input v-model="inquiry.name" type="text" :placeholder="locale === 'zh' ? '姓名 *' : 'Name *'" required>
                <input v-model="inquiry.email" type="email" :placeholder="locale === 'zh' ? '邮箱 *' : 'Email *'" required>
              </div>
              <input v-model="inquiry.company" type="text" :placeholder="locale === 'zh' ? '公司名称' : 'Company'">
              <textarea v-model="inquiry.message" rows="5" :placeholder="locale === 'zh' ? '我们能帮上什么忙？ *' : 'How can we help? *'" required></textarea>
              <button type="submit" class="btn-primary btn-full" :disabled="submitting">
                {{ submitting ? (locale === 'zh' ? '发送中...' : 'Sending...') : (locale === 'zh' ? '发送咨询' : 'Send Inquiry') }}
              </button>
              <p class="form-note">{{ locale === 'zh' ? '您的咨询会直接发送到我们的团队，我们会尽快回复。' : 'Your inquiry will be sent to our team. We will reply soon.' }}</p>
            </form>
            <div v-if="inquirySuccess" class="success-msg">
              <h3>{{ locale === 'zh' ? '提交成功！' : 'Success!' }}</h3>
              <p>{{ locale === 'zh' ? '感谢您的咨询，我们会尽快回复。' : 'Thank you! We will reply soon.' }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== 15. 咨询展板（公开显示所有咨询）========== -->
    <section class="content-block">
      <div class="container">
        <div class="block-header center">
          <span class="block-tag">{{ locale === 'zh' ? '客户咨询' : 'Client Inquiries' }}</span>
          <h2 class="block-title">{{ locale === 'zh' ? '咨询展示' : 'Inquiry Board' }}</h2>
          <p class="block-desc">{{ locale === 'zh' ? '以下是我们收到的客户咨询，欢迎了解' : 'Below are inquiries from our clients' }}</p>
        </div>
        <div v-if="consultationsLoading" class="loading-state">
          <p>{{ locale === 'zh' ? '加载中...' : 'Loading...' }}</p>
        </div>
        <div v-else-if="consultations.length === 0" class="empty-state">
          <p>{{ locale === 'zh' ? '暂无咨询记录' : 'No inquiries yet' }}</p>
        </div>
        <div v-else class="consultation-grid">
          <div class="consultation-card" v-for="(item, i) in consultations" :key="i">
            <div class="consultation-header">
              <div class="consultation-avatar">{{ item.name.charAt(0) }}</div>
              <div class="consultation-meta">
                <strong class="consultation-name">{{ item.name }}</strong>
                <span v-if="item.company" class="consultation-company">{{ item.company }}</span>
              </div>
              <span class="consultation-date">{{ formatDate(item.createdAt) }}</span>
            </div>
            <p class="consultation-message">{{ item.message }}</p>
            <div v-if="item.reply" class="consultation-reply">
              <span class="reply-label">{{ locale === 'zh' ? '回复：' : 'Reply: ' }}</span>
              <p>{{ locale === 'en' && item.reply_en ? item.reply_en : item.reply }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import axios from 'axios'
import ProductSection from './ProductSection.vue'
import NewsSection from './NewsSection.vue'
import ThemeManager from '../utils/theme'
import { getImageFullUrl as getFullImageUrlUtil } from '../utils/image'

export default {
  name: 'Home',
  components: { ProductSection, NewsSection },
watch: {
    '$i18n.locale'() {
        this.initContent()
        this.initContactCards()
    }
},
  data() {
    return {
      // locale: 'zh',
      siteConfig: {},
      contactInfo: { email: '', phone: '', address: '' },
      aboutContent: { content: '', images: [] },
      currentImageIndex: 0,
      inquiry: { name: '', email: '', company: '', message: '' },
      submitting: false,
      inquirySuccess: false,
      statsData: [],
      aboutFeatures: [],
      capabilities: [],
      qualityChecks: [],
      processSteps: [],
      reasons: [],
      factoryChecks: [],
      testimonials: [],
      certifications: [],
      partners: [],
      faqs: [],
      activeFaq: null,
      contactCards: [],
      consultations: [],
      consultationsLoading: false
    }
  },
  computed: {
    locale() {
        return this.$i18n ? this.$i18n.locale : (localStorage.getItem('locale') || 'zh')
    }
},
  created() {
    this.initContent()
    this.updateSiteData()
  },
  methods: {
    getImageFullUrl(url) {
      return getFullImageUrlUtil(url)
    },
    handleImageError(e) {
      e.target.style.display = 'none'
    },
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--
      } else {
        this.currentImageIndex = this.aboutContent.images.length - 1
      }
    },
    nextImage() {
      if (this.currentImageIndex < this.aboutContent.images.length - 1) {
        this.currentImageIndex++
      } else {
        this.currentImageIndex = 0
      }
    },
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    },
    async submitInquiry() {
      if (this.submitting) return
      this.submitting = true
      try {
        await axios.post('/api/contact', this.inquiry)
        this.inquirySuccess = true
        this.inquiry = { name: '', email: '', company: '', message: '' }
        setTimeout(() => { this.inquirySuccess = false }, 5000)
      } catch (e) {
        alert(this.locale === 'zh' ? '发送失败，请稍后重试' : 'Failed to send, please try again')
      } finally {
        this.submitting = false
      }
    },
    async updateSiteData() {
      // 每个 API 独立请求，不互相拖累
      // 加载站点配置（可选）
      try {
        const configRes = await axios.get('/api/site-configs/map')
if (configRes.data) this.siteConfig = configRes.data
      } catch (e) {
        console.log('No site config, using defaults')
      }
      
      // 加载关于我们（可选）
      try {
        const aboutRes = await axios.get('/api/about')
        if (aboutRes.data) this.aboutContent = aboutRes.data
      } catch (e) {
        console.log('No about content, using defaults')
      }
      
      // 加载联系信息（可选）
      try {
        const contactRes = await axios.get('/api/contact-info')
        if (contactRes.data) this.contactInfo = contactRes.data
      } catch (e) {
        console.log('No contact info, using defaults')
      }
      
      // 加载首页自定义内容（核心服务、合作流程、优势等）
      console.log('Fetching home content from API...')
      try {
        const contentRes = await axios.get('/api/home-content')
        console.log('Home content API response:', contentRes.status, contentRes.data)
        if (contentRes.data) {
          const data = contentRes.data
          console.log('Home content keys:', Object.keys(data))
          if (data.capabilities) {
            console.log('Setting capabilities:', data.capabilities.length, 'items')
            this.capabilities = data.capabilities
          }
          if (data.processSteps) this.processSteps = data.processSteps
          if (data.reasons) this.reasons = data.reasons
          if (data.testimonials) this.testimonials = data.testimonials
          if (data.certifications) this.certifications = data.certifications
          if (data.partners) this.partners = data.partners
          if (data.faqs) this.faqs = data.faqs
        } else {
          console.log('Home content response data is empty')
        }
      } catch (e) {
        console.log('No custom home content, using defaults - error:', e.message)
      }
      
      this.initContent()
      this.initContactCards()
      this.loadConsultations()
    },
    initContactCards() {
    const zh = this.locale === 'zh'
    const cfg = this.siteConfig
    this.contactCards = [
        { icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>', title: zh ? '邮箱' : 'Email', value: cfg.contact_email || (zh ? 'contact@example.com' : 'contact@example.com') },
        { icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>', title: zh ? '电话' : 'Phone', value: cfg.contact_phone || (zh ? '+86 123 4567 8900' : '+1 (555) 123-4567') },
        { icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>', title: zh ? '地址' : 'Address', value: cfg.contact_address || (zh ? '广东省深圳市龙岗区' : 'Longgang District, Shenzhen, China') }
    ]
},
    initContent() {
      const zh = this.locale === 'zh'
      
      this.statsData = [
        { icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>', num: '15+', label: zh ? '年行业经验' : 'Years Experience' },
        { icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>', num: '500+', label: zh ? '合作客户' : 'Clients' },
        { icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>', num: '2000+', label: zh ? '产品系列' : 'Products' },
        { icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>', num: '98%', label: zh ? '客户满意度' : 'Satisfaction' }
      ]
      
      if (this.capabilities.length === 0) {
        this.capabilities = [
          { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="1.5"><path d="M12 19l7-7 3 3-7 7-3-3z"/><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/><path d="M2 2l7.586 7.586"/><circle cx="11" cy="11" r="2"/></svg>', title: zh ? '产品定制' : 'Custom Design', desc: zh ? '根据需求定制产品，满足个性化要求' : 'Customize products to meet individual needs' },
          { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>', title: zh ? 'OEM/ODM' : 'OEM/ODM Service', desc: zh ? '提供代工和原始设计制造服务' : 'OEM and ODM manufacturing services' },
          { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="1.5"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>', title: zh ? '质量控制' : 'Quality Control', desc: zh ? '严格的质量管理体系，确保产品品质' : 'Strict quality management system' },
          { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="1.5"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>', title: zh ? '物流配送' : 'Logistics', desc: zh ? '全球物流网络，安全快速交付' : 'Global logistics network, safe delivery' },
          { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="1.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>', title: zh ? '专业团队' : 'Professional Team', desc: zh ? '经验丰富的专业团队，提供全程服务' : 'Experienced team, full service' },
          { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--sage-dark)" stroke-width="1.5"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>', title: zh ? '售后支持' : 'After-sales Support', desc: zh ? '完善的售后服务体系，让您无后顾之忧' : 'Complete after-sales service system' }
        ]
      }
      
      this.qualityChecks = [
        zh ? '原材料检验 - 每批材料严格检测' : 'Raw Material Inspection',
        zh ? '生产过程监控 - 全程质量跟踪' : 'Process Monitoring',
        zh ? '半成品检测 - 中间环节把控' : 'Semi-finished Inspection',
        zh ? '成品检验 - 出厂前全面检测' : 'Final Product Inspection',
        zh ? '包装检查 - 确保运输安全' : 'Packaging Check',
        zh ? '出货前复检 - 最后品质把关' : 'Pre-shipment Re-inspection'
      ]
      
      if (this.processSteps.length === 0) {
        this.processSteps = [
          { number: '01', title: zh ? '需求沟通' : 'Requirement', desc: zh ? '深入了解客户需求' : 'Understand client needs' },
          { number: '02', title: zh ? '方案设计' : 'Design', desc: zh ? '制定详细解决方案' : 'Detailed solution design' },
          { number: '03', title: zh ? '样品确认' : 'Sample', desc: zh ? '快速打样确认' : 'Fast sampling' },
          { number: '04', title: zh ? '批量生产' : 'Production', desc: zh ? '按时按质交付' : 'On-time quality delivery' }
        ]
      }
      
      if (this.reasons.length === 0) {
        this.reasons = [
          { icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>', title: zh ? '品质保证' : 'Quality Assurance', desc: zh ? 'ISO9001认证，严格品控' : 'ISO9001 certified, strict QC' },
          { icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>', title: zh ? '快速响应' : 'Fast Response', desc: zh ? '24小时内回复咨询' : 'Reply within 24 hours' },
          { icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>', title: zh ? '价格优势' : 'Competitive Price', desc: zh ? '工厂直供，性价比高' : 'Factory direct, cost-effective' },
          { icon: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>', title: zh ? '定制能力' : 'Customization', desc: zh ? '灵活的OEM/ODM服务' : 'Flexible OEM/ODM service' }
        ]
      }
      
      if (this.testimonials.length === 0) {
        this.testimonials = [
          { name: zh ? '张总' : 'John Z.', company: zh ? '知名家居品牌' : 'Home Brand', role: zh ? '采购总监' : 'Procurement Dir.', text: zh ? '合作5年，产品质量始终如一，交期准时。' : 'Partnered for 5 years, consistent quality.' },
          { name: 'Sarah J.', company: zh ? '欧洲零售集团' : 'EU Retail Group', role: zh ? '产品经理' : 'Product Mgr.', text: zh ? '定制化能力强，响应速度快，强烈推荐！' : 'Strong customization, fast response!' },
          { name: zh ? '李经理' : 'Manager Li', company: zh ? '北美贸易公司' : 'NA Trading Co.', role: 'CEO', text: zh ? '沟通无障碍，合作非常顺畅。' : 'Seamless communication, smooth cooperation.' }
        ]
      }
      
      if (this.certifications.length === 0) {
        this.certifications = [
          { icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>', title: 'ISO 9001', desc: zh ? '质量管理' : 'Quality' },
          { icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M16 8l-4 4-4-4M8 12l4 4 4-4"/></svg>', title: 'ISO 14001', desc: zh ? '环境管理' : 'Environmental' },
          { icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>', title: 'OHSAS 18001', desc: zh ? '职业健康安全' : 'Health & Safety' },
          { icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>', title: 'BSCI', desc: zh ? '社会责任' : 'Social Compliance' },
          { icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>', title: 'SGS', desc: zh ? '第三方检测' : 'Third-party Test' },
          { icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>', title: 'CE/FCC', desc: zh ? '产品安全' : 'Product Safety' }
        ]
      }
      
      if (this.partners.length === 0) {
        this.partners = ['IKEA', 'Walmart', 'Amazon', 'Target', 'Home Depot', 'Costco']
      }
      
      if (this.faqs.length === 0) {
        this.faqs = [
          { question: zh ? 'MOQ（最小起订量）是多少？' : 'What is the MOQ?', answer: zh ? '标准产品MOQ为500-1000件，定制产品可协商。支持小批量试单。' : 'Standard MOQ 500-1000 units, custom negotiable.' },
          { question: zh ? '样品开发需要多长时间？' : 'Sample lead time?', answer: zh ? '标准样品7-10个工作日，复杂产品2-3周。' : 'Standard samples 7-10 days, complex 2-3 weeks.' },
          { question: zh ? '生产周期一般是多久？' : 'Production lead time?', answer: zh ? '常规订单25-35个工作日，旺季可能延长。' : 'Regular orders 25-35 days, longer in peak season.' },
          { question: zh ? '接受哪些付款方式？' : 'Payment methods?', answer: zh ? 'T/T、L/C、Western Union、PayPal。30%定金，70%发货前付清。' : 'T/T, L/C, WU, PayPal. 30% deposit, 70% before shipping.' },
          { question: zh ? '如何保证产品质量？' : 'How to ensure quality?', answer: zh ? '全流程质量控制：原材料检验→过程监控→半成品检测→成品抽检→出货检验。' : 'Full-process QC from raw material to shipment.' },
          { question: zh ? '是否可以OEM/ODM定制？' : 'OEM/ODM available?', answer: zh ? '当然！专业研发团队提供完整OEM/ODM服务。' : 'Yes! Professional R&D team for complete OEM/ODM.' }
        ]
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    async loadConsultations() {
      this.consultationsLoading = true
      try {
        const res = await axios.get('/api/consultations/public')
        if (res.data && Array.isArray(res.data)) {
          this.consultations = res.data
        }
      } catch (e) {
        console.log('Failed to load consultations:', e.message)
      } finally {
        this.consultationsLoading = false
      }
    }
  }
}
</script>

<style scoped>
/* ===== 全局变量 ===== */
:root {
  --sage: #7a8e6a;
  --sage-dark: #5c6b50;
  --cream: #f8f6f0;
  --sand: #e8e4d9;
  --bark: #3d3d3d;
  --stone: #666;
  --wheat: #d4a574;
}

/* ===== 基础布局 ===== */
.home-container { overflow-x: hidden; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

/* ===== 内容块通用样式 ===== */
.content-block { padding: 70px 0; }
.content-block.block-light { background: var(--cream); }
.products-compact { padding: 70px 0; }

.block-header { margin-bottom: 44px; }
.block-header.center { text-align: center; }
.block-tag { display: inline-block; background: var(--sage); color: #fff; padding: 6px 16px; border-radius: 20px; font-size: 13px; font-weight: 600; letter-spacing: 0.5px; margin-bottom: 16px; }
.block-tag.tag-light { background: rgba(255,255,255,0.2); }
.block-title { font-size: 36px; color: var(--bark); margin-bottom: 16px; font-weight: 700; line-height: 1.3; }
.block-title.light { color: #fff; }
.block-desc { font-size: 16px; color: var(--stone); max-width: 600px; line-height: 1.7; }
.block-desc.light { color: rgba(255,255,255,0.85); }
.block-header.center .block-desc { margin: 0 auto; }

/* ===== 1. HERO 块 ===== */
.hero-block {
  position: relative;
  min-height: 620px;
  display: flex;
  align-items: center;
  background: linear-gradient(160deg, #0f1724 0%, #1a2332 45%, #0f1724 100%);
  padding: 120px 0 80px;
  overflow: hidden;
}
.hero-overlay {
  position: absolute;
  inset: 0;
  background: url('https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&h=900&fit=crop') center/cover no-repeat;
  opacity: 0.12;
}
/* 几何装饰 */
.hero-pattern {
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(30deg, rgba(201,149,74,0.03) 12%, transparent 12.5%, transparent 87%, rgba(201,149,74,0.03) 87.5%),
    linear-gradient(150deg, rgba(201,149,74,0.03) 12%, transparent 12.5%, transparent 87%, rgba(201,149,74,0.03) 87.5%),
    linear-gradient(30deg, rgba(201,149,74,0.03) 12%, transparent 12.5%, transparent 87%, rgba(201,149,74,0.03) 87.5%),
    linear-gradient(150deg, rgba(201,149,74,0.03) 12%, transparent 12.5%, transparent 87%, rgba(201,149,74,0.03) 87.5%);
  background-size: 80px 140px;
  pointer-events: none;
  z-index: 0;
}
.hero-geo {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}
.hero-geo-1 {
  top: -100px;
  right: -60px;
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(201,149,74,0.06) 0%, transparent 70%);
}
.hero-geo-2 {
  bottom: -80px;
  left: -40px;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(122,142,106,0.05) 0%, transparent 70%);
}
.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}
.hero-badge {
  display: inline-block;
  background: rgba(212,165,116,0.15);
  color: #d4a574;
  padding: 8px 24px;
  border-radius: 25px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 28px;
  border: 1px solid rgba(212,165,116,0.2);
  text-transform: uppercase;
}
.hero-title {
  font-size: 56px;
  color: #fff;
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.15;
  letter-spacing: -0.5px;
}
.hero-desc {
  font-size: 18px;
  color: rgba(255,255,255,0.7);
  margin-bottom: 40px;
  line-height: 1.7;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 300;
}
.hero-buttons { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
.hero-buttons a {
  display: inline-block;
  text-decoration: none;
}
.hero-scroll {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}
.hero-scroll span {
  display: block;
  width: 24px;
  height: 40px;
  border: 2px solid rgba(255,255,255,0.2);
  border-radius: 12px;
  position: relative;
  animation: heroScroll 2s ease-in-out infinite;
}
.hero-scroll span::after {
  content: '';
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 8px;
  background: rgba(255,255,255,0.4);
  border-radius: 2px;
  animation: heroScrollDot 2s ease-in-out infinite;
}
@keyframes heroScroll {
  0%, 100% { transform: translateY(0); opacity: 0.5; }
  50% { transform: translateY(4px); opacity: 1; }
}
@keyframes heroScrollDot {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}
.btn-primary {
  background: #7a8e6a;
  color: #fff;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-primary:hover { background: #5c6b50; transform: translateY(-2px); box-shadow: 0 8px 20px rgba(122,142,106,0.3); }
.btn-outline {
  background: transparent;
  color: #fff;
  border: 2px solid rgba(255,255,255,0.4);
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-outline:hover { border-color: #fff; background: rgba(255,255,255,0.1); transform: translateY(-2px); }

/* ===== 2. 数据统计块（增强版）===== */
.stats-block {
  background: #fff;
  padding: 48px 0;
  border-bottom: 1px solid var(--sand);
}
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  text-align: center;
}
.stat-item {
  padding: 12px;
  position: relative;
}
.stat-item::after {
  content: '';
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 50px;
  background: var(--sand);
}
.stat-item:last-child::after { display: none; }
.stat-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  background: var(--cream);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sage-dark);
  transition: all 0.3s ease;
}
.stat-item:hover .stat-icon {
  background: var(--sage);
  color: #fff;
  transform: translateY(-4px);
}
.stat-num {
  font-size: 42px;
  font-weight: 700;
  color: var(--sage-dark);
  margin-bottom: 8px;
}
.stat-label {
  font-size: 14px;
  color: var(--stone);
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* ===== 装饰分隔条 ===== */
.divider-bar {
  padding: 0;
  background: #fff;
  display: flex;
  justify-content: center;
}
.divider-bar-inner {
  width: 100%;
  max-width: 200px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--sand), transparent);
}

/* ===== 3. 关于我们块 ===== */
.about-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}
.about-layout.center {
  grid-template-columns: 1fr;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}
.about-layout.center .feature-list {
  align-items: center;
}
.about-layout.center .feature-item {
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.about-rich { font-size: 15px; color: var(--stone); line-height: 1.8; margin-bottom: 28px; }
.feature-list { display: flex; flex-direction: column; gap: 16px; }
.feature-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.feature-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: var(--cream);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sage-dark);
}
.feature-info strong { display: block; font-size: 15px; color: var(--bark); margin-bottom: 4px; }
.feature-info span { font-size: 13px; color: var(--stone); }
.about-images { }
.image-main {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
}
.image-main img { width: 100%; height: auto; display: block; }
.image-nav {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(0,0,0,0.5);
  padding: 8px 16px;
  border-radius: 25px;
}
.image-nav button {
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
}
.nav-dots { display: flex; gap: 6px; }
.nav-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255,255,255,0.4);
  cursor: pointer;
  transition: all 0.3s ease;
}
.nav-dots span.active { background: #fff; width: 20px; border-radius: 4px; }

/* ===== 4. 核心服务块（企业级高级设计）===== */
.srv-section {
  position: relative;
  padding: 100px 0;
  background: linear-gradient(160deg, #0f1724 0%, #1a2332 40%, #0f1724 100%);
  overflow: hidden;
  isolation: isolate;
}
.srv-geo {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}
.srv-geo-1 {
  top: -200px;
  right: -100px;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(201,149,74,0.08) 0%, transparent 70%);
}
.srv-geo-2 {
  bottom: -150px;
  left: -80px;
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(122,142,106,0.06) 0%, transparent 70%);
}
.srv-geo-3 {
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
  height: 800px;
  border: 1px solid rgba(201,149,74,0.05);
  animation: srvPulse 8s ease-in-out infinite;
}
@keyframes srvPulse {
  0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.5; }
  50% { transform: translate(-50%, -50%) scale(1.1); opacity: 1; }
}
.srv-section .block-header { position: relative; z-index: 1; }
.srv-section .block-tag { background: rgba(201,149,74,0.2); color: #d4a574; }
.srv-section .block-title { color: #fff; }
.srv-section .block-desc { color: rgba(255,255,255,0.6); }

.srv-showcase {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
.srv-card-premium {
  position: relative;
  background: rgba(255,255,255,0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 20px;
  padding: 36px 32px 32px;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  cursor: default;
}
.srv-card-premium::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 20px;
  background: linear-gradient(160deg, rgba(255,255,255,0.05) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.5s ease;
}
.srv-card-premium:hover {
  transform: translateY(-8px);
  border-color: rgba(201,149,74,0.3);
  box-shadow: 0 30px 60px rgba(0,0,0,0.4), 0 0 0 1px rgba(201,149,74,0.1);
}
.srv-card-premium:hover::before { opacity: 1; }
.srv-card-number {
  font-size: 42px;
  font-weight: 800;
  color: rgba(255,255,255,0.04);
  line-height: 1;
  letter-spacing: -2px;
  margin-bottom: 16px;
  transition: all 0.4s ease;
}
.srv-card-premium:hover .srv-card-number {
  color: rgba(201,149,74,0.15);
}
.srv-card-title {
  font-size: 19px;
  color: #fff;
  font-weight: 700;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
}
.srv-card-desc {
  font-size: 14px;
  color: rgba(255,255,255,0.5);
  line-height: 1.7;
  margin-bottom: 20px;
}
.srv-card-line {
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, rgba(201,149,74,0.6), transparent);
  transition: width 0.4s ease;
}
.srv-card-premium:hover .srv-card-line {
  width: 70px;
  background: linear-gradient(90deg, #d4a574, transparent);
}
.srv-bottom {
  position: relative;
  z-index: 1;
  text-align: center;
  margin-top: 56px;
  padding-top: 40px;
}
.srv-bottom-line {
  width: 1px;
  height: 40px;
  background: linear-gradient(180deg, rgba(201,149,74,0.3), transparent);
  margin: 0 auto 24px;
}
.srv-bottom-text {
  font-size: 18px;
  color: rgba(255,255,255,0.7);
  margin-bottom: 24px;
  font-weight: 300;
  letter-spacing: 2px;
}
.btn-gold {
  background: linear-gradient(135deg, #c9954a 0%, #d4a574 100%);
  color: #1a2332;
  font-weight: 700;
  padding: 16px 40px;
  border-radius: 50px;
  letter-spacing: 1px;
  box-shadow: 0 4px 20px rgba(201,149,74,0.3);
}
.btn-gold:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(201,149,74,0.4);
  background: linear-gradient(135deg, #d4a574 0%, #c9954a 100%);
}

/* ===== 5. 品质管控块（企业级设计）===== */
.quality-block {
  background: linear-gradient(160deg, #2a3a2a 0%, var(--sage-dark) 50%, #2a3a2a 100%);
  padding: 80px 0;
  position: relative;
  overflow: hidden;
}
.quality-block::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -20%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255,255,255,0.03) 0%, transparent 70%);
  border-radius: 50%;
}
.quality-block::after {
  content: '';
  position: absolute;
  bottom: -30%;
  right: -10%;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(255,255,255,0.03) 0%, transparent 70%);
  border-radius: 50%;
}
.qc-timeline {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.qc-step {
  background: rgba(255,255,255,0.06);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 20px;
  padding: 32px 28px 28px;
  transition: all 0.4s ease;
}
.qc-step:hover {
  background: rgba(255,255,255,0.1);
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(0,0,0,0.2);
  border-color: rgba(255,255,255,0.2);
}
.qc-number {
  font-size: 40px;
  font-weight: 700;
  color: rgba(255,255,255,0.08);
  margin-bottom: 8px;
  line-height: 1;
}
.qc-content h4 {
  font-size: 17px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: 700;
}
.qc-content p {
  font-size: 13px;
  color: rgba(255,255,255,0.7);
  line-height: 1.6;
}

/* ===== 6. (已删除 - 原物流块) ===== */

/* ===== 7. 服务流程块（增强版）===== */
.steps-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  position: relative;
}
.steps-grid::before {
  content: '';
  position: absolute;
  top: 48px;
  left: 60px;
  right: 60px;
  height: 2px;
  background: linear-gradient(90deg, var(--sage), var(--sage-dark), var(--sage));
  opacity: 0.3;
}
.step-card {
  text-align: center;
  padding: 36px 20px 28px;
  background: #fff;
  border-radius: 16px;
  border: 1px solid var(--sand);
  transition: all 0.4s ease;
  position: relative;
}
.step-card:hover {
  border-color: var(--sage);
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(0,0,0,0.08);
}
.step-card .step-num {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--cream) 0%, #f0ece0 100%);
  color: var(--sage-dark);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  margin: 0 auto 20px;
  transition: all 0.4s ease;
  position: relative;
  z-index: 1;
}
.step-card:hover .step-num {
  background: linear-gradient(135deg, var(--sage) 0%, var(--sage-dark) 100%);
  color: #fff;
  transform: scale(1.1);
}
.step-card h4 {
  font-size: 17px;
  color: var(--bark);
  margin-bottom: 10px;
  font-weight: 700;
}
.step-card p {
  font-size: 13px;
  color: var(--stone);
  line-height: 1.6;
}

/* ===== 8. 核心优势块 ===== */
.advantage-block {
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
  padding: 70px 0;
}
.advantage-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.advantage-card {
  background: rgba(255,255,255,0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 16px;
  padding: 28px 20px;
  text-align: center;
  transition: all 0.3s ease;
}
.advantage-card:hover {
  background: rgba(255,255,255,0.12);
  transform: translateY(-4px);
}
.adv-icon {
  width: 52px;
  height: 52px;
  background: rgba(255,255,255,0.1);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 18px;
  color: var(--wheat);
}
.advantage-card h4 {
  font-size: 16px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: 600;
}
.advantage-card p {
  font-size: 13px;
  color: rgba(255,255,255,0.7);
  line-height: 1.5;
}

/* ===== 9. 客户评价块 ===== */
.review-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
.review-card {
  background: #fff;
  padding: 28px;
  border-radius: 16px;
  border: 1px solid var(--sand);
  transition: all 0.3s ease;
}
.review-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
}
.stars {
  color: var(--wheat);
  font-size: 18px;
  margin-bottom: 16px;
  letter-spacing: 2px;
}
.review-text {
  font-size: 14px;
  color: var(--stone);
  line-height: 1.7;
  margin-bottom: 20px;
  font-style: italic;
}
.reviewer {
  display: flex;
  align-items: center;
  gap: 12px;
}
.avatar {
  width: 44px;
  height: 44px;
  background: var(--sage);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}
.reviewer-info strong {
  display: block;
  font-size: 14px;
  color: var(--bark);
}
.reviewer-info small {
  font-size: 12px;
  color: var(--stone);
}

/* ===== 10. 认证资质块 ===== */
.cert-grid-new {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}
.cert-item {
  background: #fff;
  padding: 24px 16px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid var(--sand);
  transition: all 0.3s ease;
}
.cert-item:hover {
  border-color: var(--sage);
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.06);
}
.cert-item .cert-icon {
  color: var(--sage-dark);
  margin-bottom: 12px;
}
.cert-item strong {
  display: block;
  font-size: 15px;
  color: var(--bark);
  margin-bottom: 6px;
  font-weight: 600;
}
.cert-item span {
  font-size: 12px;
  color: var(--stone);
}

/* ===== 11. 合作伙伴块 ===== */
.partners-block {
  background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);
  padding: 60px 0;
}
.partner-logos {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}
.partner-logo {
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 12px;
  padding: 28px 16px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: rgba(255,255,255,0.6);
  letter-spacing: 1px;
  transition: all 0.3s ease;
}
.partner-logo:hover {
  background: rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.9);
  transform: translateY(-2px);
}

/* ===== 12. FAQ块 ===== */
.faq-box {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.faq-item {
  background: #fff;
  border: 1px solid var(--sand);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}
.faq-item.open {
  border-color: var(--sage);
  box-shadow: 0 4px 12px rgba(122,142,106,0.1);
}
.faq-q {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  font-weight: 500;
  color: var(--bark);
  font-size: 15px;
}
.faq-arrow {
  font-size: 24px;
  color: var(--sage);
  font-weight: 300;
  transition: transform 0.3s ease;
}
.faq-item.open .faq-arrow { transform: rotate(45deg); }
.faq-a {
  padding: 0 24px 20px;
  font-size: 14px;
  color: var(--stone);
  line-height: 1.7;
}

/* ===== 13. CTA块（企业级）===== */
.cta-block {
  background: linear-gradient(160deg, #2a3a2a 0%, var(--sage-dark) 50%, #1a2a1a 100%);
  padding: 80px 0;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.cta-block::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
}
.cta-content { max-width: 700px; margin: 0 auto; position: relative; z-index: 1; }
.cta-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 36px;
  flex-wrap: wrap;
}
.btn-outline-light {
  background: transparent;
  color: #fff;
  border: 2px solid rgba(255,255,255,0.4);
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-outline-light:hover { border-color: #fff; background: rgba(255,255,255,0.1); transform: translateY(-2px); }
.btn-full { width: 100%; }

/* ===== 14. 联系我们块 ===== */
.contact-layout {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 48px;
  align-items: start;
}
.contact-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.contact-card-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--sand);
}
.card-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: var(--cream);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sage-dark);
}
.contact-card-item strong {
  display: block;
  font-size: 15px;
  color: var(--bark);
  margin-bottom: 6px;
}
.contact-card-item p {
  font-size: 13px;
  color: var(--stone);
  line-height: 1.5;
}
.contact-form-box {
  background: #fff;
  padding: 32px;
  border-radius: 16px;
  border: 1px solid var(--sand);
}
.form-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
.contact-form-box input,
.contact-form-box textarea {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid var(--sand);
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.3s ease;
  box-sizing: border-box;
}
.contact-form-box input:focus,
.contact-form-box textarea:focus {
  outline: none;
  border-color: var(--sage);
  box-shadow: 0 0 0 3px rgba(122,142,106,0.1);
}
.contact-form-box textarea { resize: vertical; min-height: 120px; margin-bottom: 16px; }
.form-note {
  font-size: 12px;
  color: var(--stone);
  text-align: center;
  margin-top: 12px;
  line-height: 1.5;
}
.success-msg {
  margin-top: 20px;
  padding: 20px;
  background: #e8f5e9;
  border-radius: 8px;
  text-align: center;
}
.success-msg h3 {
  color: #2d8659;
  font-size: 18px;
  margin-bottom: 8px;
}
.success-msg p {
  color: #555;
  font-size: 14px;
}

/* ===== 响应式设计 ===== */
@media (max-width: 1024px) {
  .srv-showcase,
  .advantage-grid { grid-template-columns: repeat(2, 1fr); }
  .cert-grid-new { grid-template-columns: repeat(3, 1fr); }
  .partner-logos { grid-template-columns: repeat(3, 1fr); }
  .qc-timeline { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
  .content-block { padding: 50px 0; }
  .products-compact { padding: 50px 0; }
  .hero-title { font-size: 36px; }
  .hero-desc { font-size: 16px; }
  .block-title { font-size: 28px; }
  
  .stats-grid { grid-template-columns: repeat(2, 1fr); gap: 24px; }
  .stat-num { font-size: 32px; }
  .stat-item::after { display: none; }
  
  .about-layout,
  .contact-layout { grid-template-columns: 1fr; gap: 32px; }
  
  .srv-showcase,
  .steps-grid { grid-template-columns: repeat(2, 1fr); }
  .review-grid { grid-template-columns: 1fr; }
  .advantage-grid { grid-template-columns: repeat(2, 1fr); }
  .cert-grid-new { grid-template-columns: repeat(2, 1fr); }
  .partner-logos { grid-template-columns: repeat(2, 1fr); }
  .qc-timeline { grid-template-columns: 1fr; }
  
  .form-group { grid-template-columns: 1fr; }
}

@media (max-width: 480px) {
  .container { padding: 0 16px; }
  .hero-title { font-size: 28px; }
  .hero-block { min-height: 500px; padding: 80px 0 60px; }
  
  .stats-grid { grid-template-columns: 1fr 1fr; gap: 16px; }
  .stat-num { font-size: 28px; }
  
  .srv-showcase,
  .steps-grid,
  .advantage-grid,
  .cert-grid-new,
  .partner-logos { grid-template-columns: 1fr; }
  
  .review-card { padding: 20px; }
  .contact-form-box { padding: 24px 20px; }
}

/* ===== 咨询展板 ===== */
.consultation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 20px;
  margin-top: 40px;
}
.consultation-card {
  background: #fff;
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: 12px;
  padding: 24px;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}
.consultation-card:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  transform: translateY(-2px);
}
.consultation-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.consultation-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary-color, #1a56db);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}
.consultation-meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.consultation-name {
  font-size: 15px;
  color: #1e293b;
}
.consultation-company {
  font-size: 12px;
  color: #94a3b8;
}
.consultation-date {
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
  flex-shrink: 0;
}
.consultation-message {
  font-size: 14px;
  color: #475569;
  line-height: 1.7;
  margin-bottom: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}
.consultation-reply {
  padding: 12px 14px;
  background: #f0f9ff;
  border-radius: 8px;
  border-left: 3px solid var(--primary-color, #1a56db);
}
.reply-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--primary-color, #1a56db);
  display: block;
  margin-bottom: 4px;
}
.consultation-reply p {
  font-size: 13px;
  color: #334155;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}
.loading-state,
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #94a3b8;
}
@media (max-width: 768px) {
  .consultation-grid {
    grid-template-columns: 1fr;
  }
}
</style>